/**
 * Holder styr på skrivninger, som Firestore endnu ikke har bekræftet.
 * Et Firestore-løfte afsluttes først, når serveren har modtaget ændringen —
 * så længe det står åbent, er data ikke synkroniseret.
 */
let pending = 0
const listeners = new Set<() => void>()

function emit() {
  listeners.forEach((listener) => listener())
}

export function trackWrite<T>(promise: Promise<T>): Promise<T> {
  pending += 1
  emit()
  return promise.finally(() => {
    pending = Math.max(0, pending - 1)
    emit()
  })
}

export function getPendingWrites(): number {
  return pending
}

export function subscribePendingWrites(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
